import { IInitialBrandsState } from 'interfaces/brands.interface';

const initialBrandsState: IInitialBrandsState = {
  allBrands: [],
  // Pagination
  brandsWithPagination: [],
  bodyFetch: {
    search: '',
    index: 0,
    limit: 40,
  },
  isLoadingGetAllBrands: true,
  isLoadingGetPaginationBrands: true,
  thereAreMoreBrands: true,
  addMoreBrands: () => {},
  setBodySearchGetBrands: () => {},
};

export default initialBrandsState;
